export const arr = [
  {
    role: "GenomicsCE",
    name: "Genomics CE",
    url: "gce",
  },
  {
    role: "GenomicsPHA",
    name: "Genomics PHA",
    url: "gpha",
  },
  {
    role: "GenomicsSA",
    name: "Genomics SA",
    url: "gsa",
  },
  {
    role: "GenomicsAdmin",
    name: "Genomics Admin",
    url: "gnadmin",
  },
  {
    role: "GenomicsCH",
    name: "Genomics CH",
    url: "gch",
  },
  {
    role: "GenomicsResearch",
    name: "Genomics Research",
    url: "gnre",
  },
  {
    role: "GenomicsResearchLab",
    name: "Genomics Research Lab",
    url: "gnrelab",
  },
  {
    role: "GenomicsResearchUser",
    name: "Genomics Research",
    url: "gnrelab",
  },
  {
    role: "GenomicsResearchClient",
    name: "Genomics Research Client",
    url: "gnre/samples_tracker",
  },
  {
    role: "GenomTracker",
    name: "Genom",
    url: "genom",
  }
];
